import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import Input from '../base/InputWithLabel/InputWithLabel';
import ErrorComponent from '../Error/NewError';
import Button from '../base/Button/GlyphedButton';
import textTranslates from './translate.json';
import './ComplaintSearcher.scss';

const SearchComplaintForm = ({complaint, error, onClearError, onChange, onFormSubmit}) => {
    return(
        <div className="wrapper col-xs-12">
            <ErrorComponent
                error={error}
                onCloseButtonClick={onClearError} />
            <form 
                className="form-signin form-horizontal"
                onSubmit={onFormSubmit}>
                <Title
                    id="complaintSearcherTitle"
                    centerText
                    large
                    title={textTranslates.complaintSearcherTitle}/>
                <Input
                    id="number"
                    inputDivClassName="col-xs-12 col-sm-8"
                    label={textTranslates.complaintNumber}
                    labelClassName="col-xs-12 col-sm-4"
                    name="number"
                    onChange={onChange}
                    placeholder={textTranslates.complaintNumber}
                    type="text"
                    value={complaint.number}/>
                <Input
                    id="password"
                    inputDivClassName="col-xs-12 col-sm-8"
                    label={textTranslates.complaintPassword}
                    labelClassName="col-xs-12 col-sm-4"
                    maxLength={5}
                    name="password"
                    onChange={onChange}
                    placeholder={textTranslates.complaintPassword}
                    type="password"
                    value={complaint.password}/>
                <div
                    className="search-compliant-btn">
                    <Button
                        id="searchComplaintBtn"
                        large
                        label={textTranslates.searchComplaintBtn}
                        glyph="glyphicon-search"
                        type="submit"/>
                </div>
            </form>
        </div>
    );
};

SearchComplaintForm.propTypes = {
    complaint: PropTypes.shape({
        number: PropTypes.string,
        password: PropTypes.string
    }),
    onClearError: PropTypes.func,
    error: PropTypes.object,
    onChange: PropTypes.func,
    onFormSubmit: PropTypes.func
};

export default SearchComplaintForm;


// WEBPACK FOOTER //
// ./src/components/SearchComplaint/SearchComplaintForm.js